import ScalarIconMagnifyingGlass_vue_vue_type_script_setup_true_lang_default from "./ScalarIconMagnifyingGlass.vue.script.js";
//#region src/components/ScalarIconMagnifyingGlass.vue
var ScalarIconMagnifyingGlass_default = ScalarIconMagnifyingGlass_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconMagnifyingGlass_default as default };

//# sourceMappingURL=ScalarIconMagnifyingGlass.js.map